<template>
  <popup-dialog v-model="openModal">
    <span slot="header">{{ $t('generic.game_collecting_score') }}</span>
    <v-container>
      <v-row justify="center" class="py-2">
        <v-col md="6">
          <h3>
            {{ $t('generic.please_press_your_name') }}
          </h3>
        </v-col>
      </v-row>
      <v-row class="py-2">
        <v-text-field class="centered-input px-2" :placeholder="$t('generic.your_name')" required outlined rounded
                      v-model="playerName" @change="inputUsername"></v-text-field>
      </v-row>
      <v-row justify="center" class="my-2">
        <v-btn rounded color="success" @click="openModal = false"> {{ $t('generics.accept') }}
        </v-btn>
      </v-row>
    </v-container>
  </popup-dialog>
</template>
<script>
import BtnLoader from "dev/components/BtnLoader"

export default {
  name: 'PlayerNameDialog',
  components: { BtnLoader },
  props: {
    value: { type: Boolean }
  },
  data() {
    return {
      playerName: ""
    }
  },
  computed: {
    openModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    inputUsername() {
      this.$emit('update', this.playerName);
    }
  }
}
</script>
<style scoped>
.centered-input >>> input {
  text-align: center
}
</style>
